import { motion } from "motion/react";

export default function PrivacyPage() {
  return (
    <main className="w-full bg-transparent relative overflow-x-hidden pt-28 pb-24 z-10">
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-Montserrat text-xs tracking-widest uppercase text-indigo-600 dark:text-indigo-300/70 mb-6 flex items-center gap-4"
        >
          <div className="w-4 h-px bg-indigo-500/50" />
          Legal
        </motion.div>

        <motion.h1
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
          className="font-Montserrat text-5xl md:text-7xl font-bold tracking-tight mb-12 text-black dark:text-white"
        >
          Privacy Policy
        </motion.h1>

        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          className="max-w-3xl font-Montserrat text-base text-black/70 dark:text-white/70 leading-relaxed space-y-6"
        >
          <p>
            KIVAS Tech ("we," "our," or "us") is committed to protecting your
            privacy. This Privacy Policy explains how we collect, use, disclose,
            and safeguard your information when you visit our website.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Information We Collect
          </h2>
          <p>
            We may collect personal information such as your name, email
            address, phone number, and company name when you voluntarily submit
            it through our contact forms or communication channels.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            How We Use Your Information
          </h2>
          <p>
            We use the information we collect to respond to your inquiries,
            provide our services, improve our website, and communicate with you
            about our products and services.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Data Protection
          </h2>
          <p>
            We implement appropriate technical and organizational measures to
            protect your personal data against unauthorized access, alteration,
            disclosure, or destruction.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Third-Party Disclosure
          </h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal
            information to third parties without your consent, except as
            required by law.
          </p>

          <h2 className="text-xl font-bold text-black dark:text-white mt-10 mb-4">
            Contact Us
          </h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at{" "}
            <a
              href="mailto:info@kivastech.com"
              className="text-indigo-500 hover:text-indigo-400 transition-colors"
            >
              info@kivastech.com
            </a>
            .
          </p>

          <p className="text-sm text-black/40 dark:text-white/40 pt-6">
            Last updated: June 2026
          </p>
        </motion.div>
      </div>
    </main>
  );
}
